import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './components/HomePage';
import TaxCalculator from './TaxCalculator';
import NavigationBar from './components/NavigationBar';
import AboutPage from './components/AboutUs';
import TermsOfServicePage from './components/TermsOfServicePage';
import CookieConsentBanner from './components/CookieConsentBanner';

function App() {
  return (
    <Router>
      <CookieConsentBanner />
      <NavigationBar />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/calculator" element={<TaxCalculator />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/terms-of-service" element={<TermsOfServicePage />} />
      </Routes>
    </Router>
  );
}

export default App;
